
import * as ws_base from '../ws/ws_base'

import * as texto from '../util/texto'

const DOMINIO = "saldo";



export async function buscarSaldo(id_usuario, mes, ano){

	return await ws_base.get(DOMINIO, "obter", {"id_usuario": id_usuario, mes, ano});
}

export async function saldoAtual(id_usuario){

	return await ws_base.get(DOMINIO, "saldo_atual", {"id_usuario": id_usuario});
}


export async function transacao(dados){

	let retorno = await ws_base.post(DOMINIO, "transacao", dados, false);

	console.log('dados retorno: '+JSON.stringify(retorno));
	
	if(retorno== null)
		return {"codigo_transacao": null, "mensagem": ws_base.MENSAGEM_ERRO_GENERICA};
	
	if(retorno.status<=0)
		return {"codigo_transacao": null, "mensagem": texto.isNotBlanck(retorno.mensagem)?retorno.mensagem:ws_base.MENSAGEM_ERRO_GENERICA};
	
	console.log('dados retorno: '+retorno.dados.codigo_transacao);
		
	return {"codigo_transacao": retorno.dados.codigo_transacao, "mensagem":null};
}
